import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/src/app/(site)/page.tsx");
